<template>
  <v-hover>
    <v-expansion-panel slot-scope="{ hover }" :class="`email-conversation elevation-${hover ? 2 : 0}`" expand
      class="mt-0 comms-room border-bottom">
      <v-expansion-panel-content hide-actions>
        <template v-slot:header>
          <div class="header">
            <div class="icon">
              <v-icon color="secondary">email</v-icon>
            </div>
            <div class="subject">
              <div class="conversation-header-title">
                <h4 class="unread d-inline-block">
                    {{ thread.subject }}
                  <span class="message-count">({{ thread.messages.length }})</span>
                </h4>
              </div>
            </div>
            <div class="actions">
              <MessageSendStatusPill v-if="threadHasStatus && threadStatusMessage" class=""
                :status="threadStatusMessage.sendStatus" :detail="threadStatusDetail"
                :verified-at="threadStatusVerifiedAt"
                :updated-at="threadStatusMessage ? (threadStatusMessage.updatedAt || threadStatusMessage.createdAt) : undefined"
                dense />
              <v-tooltip top color="secondary" class="">
                <v-btn slot="activator" icon small class="mr-0"
                  @click.stop="replyToEmail(parseInt(thread.id, 10), thread.subject, false)">
                  <v-icon color="secondary">reply</v-icon>
                </v-btn>
                <span>Reply</span>
              </v-tooltip>
              <v-tooltip top color="secondary" class="">
                <v-btn slot="activator" icon small class="mr-0"
                  @click.stop="replyToEmail(parseInt(thread.id, 10), thread.subject, true)">
                  <v-icon color="secondary">reply_all</v-icon>
                </v-btn>
                <span>Reply to All</span>
              </v-tooltip>

              <v-tooltip v-if="isRead" top color="secondary" class="">
                <v-btn slot="activator" icon small @click.stop="markRead()" class="mr-0">
                  <font-awesome-icon class="secondary--text" size="lg" :icon="['fas', 'eye-slash']">
                  </font-awesome-icon>
                </v-btn>
                <span>Mark conversation as unread</span>
              </v-tooltip>
              <v-tooltip v-if="!isRead" top color="secondary" class="">
                <v-btn slot="activator" icon small class="mr-0" @click.stop="markRead()">
                  <font-awesome-icon class="secondary--text" size="lg" :icon="['fas', 'eye']"></font-awesome-icon>
                </v-btn>
                <span>Mark conversation as read</span>
              </v-tooltip>
              <v-tooltip top color="secondary" class="">
                <v-btn slot="activator" class="mr-0" icon small @click.stop="showDetatchDialog = true">
                  <font-awesome-icon class="secondary--text" size="lg"
                    :icon="['fas', 'minus-circle']"></font-awesome-icon>
                </v-btn>
                <span>Detatch conversation from case</span>
              </v-tooltip>
              <v-tooltip top color="secondary" class="">
                <v-btn slot="activator" icon small>
                  <font-awesome-icon class="secondary--text" size="lg"
                    :icon="['fas', 'arrow-up-right-from-square']"></font-awesome-icon>
                </v-btn>
                <span>Pop out email</span>
              </v-tooltip>
              <!-- <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition"
                class="hidden-md-and-up">
                <v-btn flat slot="activator" icon class="ma-0 pa-0" small dark color="secondary" @click.stop>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile v-if="isRead" @click="markRead()">
                    <font-awesome-icon class="secondary--text" size="lg"
                      :icon="['fas', 'eye-slash']"></font-awesome-icon>Mark as unread
                  </v-list-tile>
                  <v-list-tile v-if="!isRead" @click="markRead()">
                    <font-awesome-icon class="secondary--text" size="lg"
                      :icon="['fas', 'eye-slash']"></font-awesome-icon>Mark as read
                  </v-list-tile>
                  <v-list-tile @click="showDetatchDialog = true">
                    <font-awesome-icon class="secondary--text" size="lg"
                      :icon="['fas', 'minus-circle']"></font-awesome-icon>
                    Detatch conversation from case
                  </v-list-tile>
                </v-list>
              </v-menu> -->
            </div>
            <div class="date">
              {{ thread.messages && thread.messages.length > 0 && thread.messages[thread.messages.length - 1] ?
                formatDate(thread.messages[thread.messages.length - 1].createdAt) : '' }}
            </div>
          </div>
        </template>

        <v-flex xs12 px-0>
          <v-card class="email elevation-0 pa-4 pt-0" style="background:rgba(255,255,255,1);"
            v-for="(message, index) in thread.messages" :key="index">
            <v-layout column wrap>
              <div class="message-header">
                <div class="message-header-content">
                  <div class="message-header-info">
                    <div class="opacity-54 message-header-label">From:</div>
                    <div class="message-header-value">
                      <span :title="message.from.email || message.from.displayName">{{ formatFromEmail(message.from) }}</span>
                    </div>
                    <div class="opacity-54 message-header-label recipients">To:</div>
                    <div class="message-header-value recipients">
                      <span v-for="(recipient, index) in message.recipients" :key="index">
                        <span v-if="index > 0" class="d-inline-block mr-2">;</span>
                        <span class="d-inline-block">{{ formatRecipientEmail(recipient) }}</span>
                      </span>
                    </div>
                    <div class="opacity-54 message-header-label recipients">Date:</div>
                    <div class="message-header-value date">
                      <span>{{ formatDate(message.createdAt) }}</span>
                    </div>
                  </div>
                </div>
                <div class="message-header-actions">
                  <div v-if="shouldShowRetry(message)" class="message-retry-wrapper">
                    <button 
                      class="retry-button" 
                      :disabled="isRetrying(parseInt(message.id, 10))"
                      @click.stop="retryMessage(message)">
                      {{ isRetrying(parseInt(message.id, 10)) ? 'Retrying...' : retryButtonLabel(message) }}
                    </button>
                  </div>
                </div>
              </div>

              <v-card class="elevation-0">
                <v-layout row xs12 md12>
                  <v-flex class="px-0 pb-0 mx-20 my-2 pt-1" xs12 md12>
                    <MessageFrame :messageId="message.id" />
                  </v-flex>
                </v-layout>

              </v-card>
              <v-card v-if="getNonInlineAttachments(message).length > 0" class="elevation-0 mt-2 attachments">
                <v-card-title class="pa-2 pb-1">
                  <h4 class="subheading">Attachments</h4>
                </v-card-title>
                <v-card-text class="pa-2 pt-0">
                  <v-list dense class="attachment-list">
                    <v-list-tile v-for="attachment in getNonInlineAttachments(message)" :key="attachment.id"
                      :href="getAttachmentUrl(attachment)" target="_blank" class="pa-0 attachment-item">
                      <div class="attachment-icon-wrapper"
                        :style="{ backgroundColor: getIconForMimeType(attachment.contentType, attachment.filename).color }">
                        <font-awesome-icon
                          :icon="[getIconForMimeType(attachment.contentType, attachment.filename).iconSet, getIconForMimeType(attachment.contentType, attachment.filename).iconName]"
                          class="attachment-icon" size="lg" />
                      </div>
                      <v-list-tile-content class="attachment-content">
                        <v-list-tile-title class="attachment-filename">
                          {{ attachment.filename }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="attachment-size">
                          {{ formatFileSize(attachment.size) }} • {{ attachment.contentType }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-layout>
          </v-card>
        </v-flex>
        <v-dialog v-model="showDetatchDialog" width="400">
          <v-card class="pa-4">
            <v-card-title class="pa-0 pb-2">
              <h2>Detatch Conversation</h2>
            </v-card-title>
            <v-card-text class="pa-0">
              <p>Are you sure you want to detach this conversation from this case?</p>
            </v-card-text>
            <v-card-actions class="ma-0 pa-0 pt-1">
              <v-btn @click="detatchConversation()" id="useredit-save-dialog-save-btn" color="error">
                OK
              </v-btn>
              <v-btn id="useredit-save-dialog-cancel-btn" @click="showDetatchDialog = false" color="primary">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-hover>
</template>

<script>
import Helpers from '@/helpers.js'
import MessageFrame from "@/components/comms/MessageFrame.vue"
import MessageSendStatusPill from "@/components/comms/MessageSendStatusPill.vue"
import { mapState } from "vuex"
import { subscribeToCommsMessageStatus, unsubscribeFromCommsMessageStatus } from "@/provider/conversations"
import { getIconForMimeType } from "@/lib/mimeTypeIcons.js"

import BadgePill from "@/components/shared/BadgePill.vue"

const STATUS_PRIORITY = {
  failed: 5,
  verification_failed: 4,
  sending: 3,
  sent: 2,
  verified: 1,
}

export default {
  name: "ConversationsList",
  components: { MessageFrame, MessageSendStatusPill, BadgePill },
  props: {
    thread: {
      type: Object,
      required: true
    },
    allParticipants: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    showDetatchDialog: false,
    retryingMessageIds: [],
    messageStatusSubscriptions: {},
  }),
  computed: {
    ...mapState({
      currentCase: state => state.cases.currentlySelected.case,
      user: state => state.currentUser,
      userPreferences: state => state.currentUser.me.preferences
    }),
    isRead() {
      return !this.thread.unread
    },
    threadMessagesWithStatus() {
      if (!this.thread || !this.thread.messages) {
        return []
      }
      // Only include outbound messages - check if from.type is "User" (sent by user in system)
      return this.thread.messages.filter(message => {
        if (!message || !message.sendStatus) {
          return false
        }
        // Only show status for outbound messages (from.type === "User")
        // Inbound messages have from.type !== "User" (e.g., "Custom", external email addresses)
        return message.from && message.from.type === "User"
      })
    },
    threadStatusMessage() {
      if (this.threadMessagesWithStatus.length === 0) {
        return null
      }
      const sorted = [...this.threadMessagesWithStatus].sort((a, b) => {
        const severityDiff = (STATUS_PRIORITY[b.sendStatus] || 0) - (STATUS_PRIORITY[a.sendStatus] || 0)
        if (severityDiff !== 0) {
          return severityDiff
        }
        const aDate = new Date(a.updatedAt || a.createdAt || 0).getTime()
        const bDate = new Date(b.updatedAt || b.createdAt || 0).getTime()
        return bDate - aDate
      })
      return sorted[0]
    },
    threadHasStatus() {
      // Only show status pill for outbound messages (from.type === "User")
      // Inbound emails (received messages) should not show the send status pill

      // Check: ensure we have a status message from an outbound message
      if (!this.threadStatusMessage) {
        return false
      }

      // Check: ensure the message is outbound (from.type === "User")
      // Inbound messages have from.type !== "User" (e.g., "Custom" for external senders)
      if (!this.threadStatusMessage.from || this.threadStatusMessage.from.type !== "User") {
        return false
      }

      // Check: ensure we have a valid sendStatus
      const status = this.threadStatusMessage.sendStatus
      if (!status) {
        return false
      }

      // Only show for outbound messages with valid statuses
      return true
    },
    threadStatusDetail() {
      return this.threadStatusMessage ? this.threadStatusMessage.sendStatusDetail : ""
    },
    threadStatusVerifiedAt() {
      return this.threadStatusMessage ? this.threadStatusMessage.sendVerifiedAt : undefined
    }
  },
  methods: {
    replyToEmail(conversationId, conversationSubject, replyAll = false) {
      this.$store.dispatch("composeNewMessage", { currentCase: this.currentCase, conversationId, conversationSubject, replyAll })
    },
    async replyToMessage(message) {
      delete message.caseId
      delete message.subject
      await this.$store.dispatch("replyCaseConversation", message)
      this.$emit("detatched-conversation")
    },
    async detatchConversation() {
      this.showDetatchDialog = false
      const conversationId = parseInt(this.thread.id)
      await this.$store.dispatch("removeConversationFromCase", conversationId)
      this.$emit("detatched-conversation")
    },
    formatDate(date) {
      if (this.userPreferences.dateTimeFormat) {
        return Helpers.formatDate(date, this.userPreferences.dateTimeFormat)
      } else {
        return Helpers.formatDate(date, "Do MMM YYYY HH:mm")
      }
    },
    async markRead() {
      const data = { conversationId: parseInt(this.thread.id), markRead: !this.isRead }
      await this.$store.dispatch("markConversationAsRead", data)
    },
    toggleMessages() {
      this.$emit("toggle-messages", this.thread)
    },
    shouldShowRetry(message) {
      return message && ["failed", "verification_failed"].includes(message.sendStatus)
    },
    retryButtonLabel(message) {
      if (!message) {
        return "Retry"
      }
      return message.sendStatus === "verification_failed" ? "Retry Verification" : "Retry Send"
    },
    isRetrying(messageId) {
      return this.retryingMessageIds.includes(messageId)
    },
    async retryMessage(message) {
      if (!message || !message.id) {
        return
      }
      const messageId = parseInt(message.id, 10)
      if (Number.isNaN(messageId) || this.isRetrying(messageId)) {
        return
      }
      this.retryingMessageIds.push(messageId)
      try {
        const success = await this.$store.dispatch("resendConversationMessage", { messageId })
        if (success && this.currentCase && this.currentCase.id) {
          this.$emit("detatched-conversation")
        }
      } finally {
        this.retryingMessageIds = this.retryingMessageIds.filter(id => id !== messageId)
      }
    },
    isInboundMessage(message) {
      if (!message || !message.from) {
        return false
      }
      // Inbound messages have from.type !== "User" (e.g., "Custom" for external senders)
      // Outbound messages have from.type === "User"
      // If type is undefined, default to treating as outbound (safer default)
      if (message.from.type === undefined || message.from.type === null) {
        return false
      }
      return message.from.type !== "User"
    },
    getLastMessageDisplay(messages) {
      if (!messages || messages.length === 0) {
        return ""
      }
      // Get the last (most recent) message
      const message = messages[messages.length - 1]
      if (!message) {
        return ""
      }
      return this.getMessageDisplay(message)
    },
    getMessageDisplay(message) {
      if (!message) {
        return ""
      }
      // Check if message.from exists - for some send failures, from may be undefined
      if (!message.from) {
        // If from is missing, try to show recipients if available
        if (message.recipients && message.recipients.length > 0) {
          const recipientAddresses = message.recipients
            .map(recipient => this.formatRecipientEmail(recipient))
            .filter(addr => addr)
            .join(", ")
          return recipientAddresses ? `To: ${recipientAddresses}` : "To: (no recipients)"
        }
        return "(no sender/recipient info)"
      }
      if (this.isInboundMessage(message)) {
        // For inbound messages, show "From: [from address]"
        const fromAddress = this.formatFromEmail(message.from)
        return fromAddress ? `From: ${fromAddress}` : ""
      } else {
        // For outbound messages, show "To: [to address]"
        if (!message.recipients || message.recipients.length === 0) {
          return "To: (no recipients)"
        }
        // Format all recipients
        const recipientAddresses = message.recipients
          .map(recipient => this.formatRecipientEmail(recipient))
          .filter(addr => addr)
          .join(", ")
        return recipientAddresses ? `To: ${recipientAddresses}` : "To: (no recipients)"
      }
    },
    formatFromEmail(from) {
      if (!from) {
        return ""
      }
      return this.formatRecipientEmail(from)
    },
    formatRecipientEmail(recipient) {
      if (!recipient) {
        return ""
      }
      const email = recipient.email || ""
      const displayName = recipient.displayName || ""

      // If no email, return in standard format with "no-email-available"
      if (!email) {
        if (displayName) {
          return `${displayName} <no-email-available>`
        }
        return "no-email-available"
      }

      // If displayName exists and is different from email, show "Display Name <email>"
      if (displayName && displayName !== email) {
        return `${displayName} <${email}>`
      }

      // Otherwise, just show the email
      return email
    },
    getNonInlineAttachments(message) {
      if (!message.attachments) return []
      return message.attachments.filter(att => !att.isInline)
    },
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return "0 Bytes"
      const k = 1024
      const sizes = ["Bytes", "KB", "MB", "GB"]
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + " " + sizes[i]
    },
    getAttachmentUrl(attachment) {
      const token = window.localStorage.getItem('session')
      const path = attachment.url
      const baseURL = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${path}` : path
      return `${baseURL}?token=${token}`
    },
    getIconForMimeType,
    updateMessageStatus(updatedMessage) {
      // Find and update the message in the thread
      if (!this.thread || !this.thread.messages) {
        return
      }
      const messageIndex = this.thread.messages.findIndex(msg => String(msg.id) === String(updatedMessage.id))
      if (messageIndex !== -1) {
        // Update the message status fields
        this.$set(this.thread.messages[messageIndex], 'sendStatus', updatedMessage.sendStatus)
        this.$set(this.thread.messages[messageIndex], 'sendStatusDetail', updatedMessage.sendStatusDetail)
        this.$set(this.thread.messages[messageIndex], 'sendVerifiedAt', updatedMessage.sendVerifiedAt)
        this.$set(this.thread.messages[messageIndex], 'updatedAt', updatedMessage.updatedAt)

        // If status is no longer "sending", we can unsubscribe
        if (updatedMessage.sendStatus !== "sending") {
          this.unsubscribeFromMessageStatus(updatedMessage.id)
        }
      }
    },
    subscribeToMessageStatus(messageId) {
      if (!messageId) {
        return
      }
      const messageIdKey = String(messageId)

      // Don't subscribe if already subscribed
      if (this.messageStatusSubscriptions[messageIdKey]) {
        return
      }

      const subscription = subscribeToCommsMessageStatus(messageId, (updatedMessage) => {
        this.updateMessageStatus(updatedMessage)
      })

      this.messageStatusSubscriptions[messageIdKey] = subscription
    },
    unsubscribeFromMessageStatus(messageId) {
      if (!messageId) {
        return
      }
      const messageIdKey = String(messageId)
      if (this.messageStatusSubscriptions[messageIdKey]) {
        unsubscribeFromCommsMessageStatus(messageId)
        delete this.messageStatusSubscriptions[messageIdKey]
      }
    },
    subscribeToAllSendingMessages() {
      // Subscribe to status updates for all messages in "sending" state
      if (!this.thread || !this.thread.messages) {
        return
      }

      this.thread.messages.forEach(message => {
        // Only subscribe to outbound messages (from.type === "User") that are in "sending" state
        if (message && message.from && message.from.type === "User" && message.sendStatus === "sending") {
          this.subscribeToMessageStatus(message.id)
        }
      })
    }
  },
  created() {
    // Subscribe to status updates when component is created
    this.$nextTick(() => {
      this.subscribeToAllSendingMessages()
    })
  },
  watch: {
    // Watch for new messages being added to the thread
    'thread.messages': {
      handler(newMessages) {
        if (newMessages && newMessages.length > 0) {
          // Subscribe to any new messages in "sending" state
          this.$nextTick(() => {
            this.subscribeToAllSendingMessages()
          })
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    // Clean up all subscriptions
    Object.keys(this.messageStatusSubscriptions).forEach(messageId => {
      this.unsubscribeFromMessageStatus(parseInt(messageId, 10))
    })
    this.messageStatusSubscriptions = {}
  }
}
</script>

<style lang="scss" scoped>
::v-deep  .v-expansion-panel__header {
  background-color: #e6e6e6;
}

.header {
  display: grid;
  grid-template-columns: 40px auto 1fr 120px 120px 150px;
  align-items: center;
  gap: 10px;
  width: 100%;

  background: initial;

  >.icon {
    grid-column: 1;
    justify-self: center;
  }

  >.from {
    grid-column: 3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  >.subject {
    grid-column: 2;
    min-width: 0;
  }

  >.status-pill {
    grid-column: 4;
  }

  >.actions {
    grid-column: 5;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 1;
  }

  >.date {
    grid-column: 6;
    text-align: right;
    padding-right: 10px;
  }
}

.email-conversation {
  // margin-bottom: 5px;

  .email {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    .attachments {

      // background: #e5e5e5;


      .subheading {
        font-size: 1.3em !important;
      }

      .attachment-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        background-color: initial;
      }

      .attachment-item {
        display: flex;
        align-items: stretch;
        min-height: 48px;
      }

      .attachment-icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 48px;
        padding: 8px;
        border-radius: 4px;
        margin-right: 12px;
      }

      .attachment-icon {
        color: white;
      }

      .attachment-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        padding: 0 !important;
      }


      .attachment-size {
        font-size: 12px;
        opacity: 0.7;
      }


    }
  }
}

.conversation-header-title {
  display: inline-flex;
  align-items: center;
}

.message-detail-status {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.message-retry-wrapper {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.message-header {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  width: 100%;
  align-items: start;
  min-height: auto;
}

.message-header-content {
  min-width: 0;
}

.message-header-info {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px 12px;
  align-items: start;
  row-gap: 4px;
}

.message-header-label {
  font-weight: 500;
  white-space: nowrap;
}

.message-header-value {
  text-align: left;
  word-break: break-word;
}

.message-header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
}

.retry-button {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #1976d2;
  color: white;
  transition: background-color 0.2s;
  margin-top: 8px;
}

.retry-button:hover:not(:disabled) {
  background-color: #1565c0;
}

.retry-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 968px) {
  .header {
    grid-template-columns: 40px 1fr 120px 150px;
    grid-template-rows: auto auto;
    column-gap: 10px;
    row-gap: 0px;
    padding: 5px;
    margin: 0 10px;

    >.icon {
      grid-column: 1;
      grid-row-start: 1;
      grid-row-end: 3;
      justify-self: center;
    }

    >.from {
      grid-column: 2;
      grid-row: 1;
      font-weight: 700;
    }

    >.subject {
      grid-column: 2;
      grid-row: 2;
      min-width: 0;
    }

    >.status-pill {
      grid-column: 3;
      grid-row-start: 1;
      grid-row-end: 3;
    }

    >.actions {
      grid-column: 4;
      grid-row: 2;
      justify-content: flex-end;
    }

    >.date {
      grid-column: 4;
      grid-row: 1;
      text-align: right;
    }
  }
}
</style>

<style>
.unread {
  font-weight: 500;
}

.scroll-minimise-fix {
  overflow-y: scroll;
}

.scroll-minimise-hidden {
  overflow-y: hidden;
}

.v-expansion-panel__container.email-conversation .v-avatar.expansion-avatar {
  height: 35px !important;
  width: 35px !important;
}

.v-expansion-panel__container--active.email-conversation .v-avatar.expansion-avatar {
  height: 50px !important;
  width: 50px !important;
  margin-top: 12px;
}

.v-expansion-panel__container--active.email-conversation .v-avatar.expansion-avatar.status:after {
  left: 0px;
}

.v-expansion-panel__container.email-conversation .recipients {
  display: none;
}

.v-expansion-panel__container--active.email-conversation .recipients {
  display: block;
}

.v-expansion-panel__container.email-conversation .email-right-actions {
  padding: 6px 0 0 0;
}

.v-expansion-panel__container--active.email-conversation .email-right-actions {
  padding: 14px 0 0 0;
}

.v-expansion-panel__container.email-conversation .email-right-actions .v-btn {
  display: none;
}

.v-expansion-panel__container--active.email-conversation .email-right-actions .v-btn {
  display: inline-block;
}

.v-expansion-panel__container.email-conversation .expansion-avatar .initials {
  font-size: 13px;
  padding: 0px 0 0 0;
}

.v-expansion-panel__container--active.email-conversation .expansion-avatar .initials {
  font-size: 20px;
  padding: 10px 0 13px 0;
}

.v-expansion-panel__container--active.email-conversation h4 {
  font-size: 26px;
}

.theme--light.v-expansion-panel .v-expansion-panel__container {
  border-top: none;
}

.v-expansion-panel.comms-room .v-expansion-panel__header {
  padding: 0 !important;
}

.v-expansion-panel.comms-room .v-expansion-panel__container--active .v-expansion-panel__header {
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.v-expansion-panel.comms-room.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
